import { Controller } from "@hotwired/stimulus";
import $ from 'jquery';
import 'select2';

// Connects to data-controller="search-select-2"
export default class extends Controller {
  static targets = ["select"];

  connect() {
    this.selectTargets.forEach((selectTarget) => {
      $(selectTarget).select2({
        dropdownAutoWidth: true
      }).on("select2:select", (event) => {
        const shouldSubmit = $(selectTarget).data('submit-on-select');
        if (shouldSubmit === false) {
          // nothing
        } else {
          // by default
          this.submitForm();
        }
      });
    });
  }

  disconnect() {
    this.selectTargets.forEach((selectTarget) => {
      $(selectTarget).select2('destroy');
    });
  }

  submitForm() {
    this.element.closest('form').submit();
  }
}
